import { Flex } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { RoleTag, UserTag } from "../../../../_shared";
import { _Role, _User } from "../../../../js/parsegenerated";
import { useTicketAssignment } from "../hooks/useTicketAssignment";

export const AssignmentTag = observer(() => {
  const { assignedRoles, assignedUsers } = useTicketAssignment();

  return (
    <Flex gap="8px">
      {assignedRoles.map((role: _Role) => (
        <RoleTag role={role} key={role.id} />
      ))}
      {assignedUsers.map((user: _User) => (
        <UserTag user={user} key={user.id} />
      ))}
    </Flex>
  );
});
